import { styled } from "@mui/material/styles";

export const ColorSwatchComponent = styled("span")(() => ({
  alignSelf: "center",
  display: "inline-block",
  marginRight: "10px",
  verticalAlign: "middle",
  borderRadius: "50%",
  height: "18px",
  width: "18px"
}));
